import {
  Component,
  Injectable,
  Input,
  OnInit,
  ViewChild
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { DialogService } from "../../Shared/dialog.service";
import { LosService } from "../../_LOS/services/los.service";
import { LmsService } from "../services/lms.service";
import { ReportsService } from "./../../_Reports/services/reports.service";

import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { constantUrl } from "../../Shared/constantUrl";
import { PartnerService } from "../../_Partner/services/partner.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

import { DatePipe } from "@angular/common";
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { CommonFunctions } from "../../CommonComponent/function/commonfunctions";
declare var $: any;

// Excel export code start here
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Injectable()
// Excel export code end here

@Component({
    selector: "app-lms-loanStatement",
    templateUrl: "./lms-loanStatement.component.html",
    styleUrls: ["./lms-loanStatement.component.scss"],
    standalone: false
})
export class LmsLoanStatementComponent implements OnInit {
  currentUser: any;
  FileCheckingList: any[] = [];
  ChargesJson: any[] = [];
  CustomerList: any[] = [];
  voucherModel: any = { Voucher: {}, Voucher_Detail: [] };
  ApplicationDetail: any;
  showSpinner: boolean = false;
  tableshow: boolean = false;
  TenureName: any = "Months";
  showLoanOD: boolean = false;
  showLoanODCharges: boolean = true;
  showLoanIncomeCharges: boolean = true;
  showLess_LoanDetail: boolean = false;
  showLess_FinanceDetail: boolean = false;
  showLess_CustomerDetail: boolean = false;
  showLess_AssetsDetail: boolean = false;
  LoanDetail: boolean = false;
  dataSource: any;
  assetModel: any = {};
  dataSourceLoan: any;
  displayedColumnsStatement: any;
  Collateral: any;
  displayedColumns: string[] = [];
  displayedColumnsOD: string[] = [];
  displayedColumnsODCharges: string[] = [];
  displayedChargesColumns: string[] = [];
  dataSourceLoanODCharges: any;
  dataSourceLoanIncomeCharges: any;
  dataSourceChargesDetail: any;
  dataSourceLoanOD: any;
  ChargeHeadId: any[] = [];
  selectedItems: any[] = [];
  Customer: any = {};
  loading: boolean = false;
  withAccountSummary: boolean = false;
  ChargesName: any = "";
  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;
  myForm: UntypedFormGroup;
  disabled = false;
  ShowFilter = true;
  limitSelection = false;
  dropdownSettings: any = {};
  chargesHeadDropdown: any[] = [];
  applicationDocUrl: any = constantUrl.CrcApplicationDocUrl;
  ApplicationNo: any;
  LoanNo: any;
  dataSourceCustomer: any;
  assetTotal: any;
  displayedCustomerColumns: string[] = [];
  dataAssetItemSource: any;
  customerDataSource: any;
  customerData: any;
  ROW: any;
  displayedAssetItemColumns: string[] = [];
  VoucherDateTo: any = new Date();
  hoveredRow: any = null;
  hoverX: number = 0;
  hoverY: number = 0;
  soaSections = {
    loanDetail: true,
    customerDetail: true,
    financeDetail: true,
    emiDetail: true,
    accountSummary: true,
    accountDetail: true,
    odDetail: true,
    monthlyDPD: true,
    IncludingStock: true,
    OtherDues: true,
    DVVoucher: true,
    InstrumentsClear: true,
    InstrumentsBounce: true,
    AssetsDetail: true,
    disbursementDetail: true,
  };
  statementSections = {
    loanDetail: true,
    customerDetail: true,
    financeDetail: true,
    emiDetail: true,
    accountSummary: true,
    installmentDetail: true,
    disbursementDetail: true,
  }
  repaymentInstrumentsClear: any[] = [];
  repaymentInstrumentsBounce: any[] = [];
  soaSelectAll = true;
  StatementSelectAll = true;
  monthlyDPDColumns: string[] = [];
  monthlyDPDList: any[] = [];
  filteredSOASectionList: any[] = [];
  filteredStatementSectionList: any[] = [];
  monthlyDPDIgnoredKeys = [
    "Loan_Id",
    "Application_No",
    "LoanCreatedOn",
    "Loan_Date",
    "LoanAcNo",
    "Application_BranchId",
    "Application_PrductId",
    "Branch_Name",
    "Product_Name",
  ];

  displayedCustomerDetailColumns: string[] = [
    "CustomerId",
    "Customer",
    "CustomerType",
    "GenderAge",
    "ExistingCustomer",
    // "Customer_IsFirm",
    "Relation_With_Hirer",
    "PhoneNo",
    "Present_Address",
    "Detail",
  ];
  displayedLoanColumns: string[] = [
    "Type",
    "CaseNo",
    "Customer",
    "Branch",
    "Category",
    "AccountHead",
    "AmountDR",
    "AmountCR",
  ];

  displayedAccountingColumns: string[] = [
    "AccountHead",
    "Branch",
    "AmountDR",
    "AmountCR",
  ];
  ShowDelete: boolean = false;
  displayedAssetsColumns: any[] = [
    "AssetId",
    "Collateral_Type",
    "Collateral",
    "ValuationType",
    "ValuationAmount",
    "ValuationDate",
    "ActionView",
    "Action",
  ];
  dataSourceAssets: any;
  Type: any = "0";
  @Input() loanSummary: any;
  @Input() isShowHeader: boolean = true;
  SourceAssets: any[] = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("paginatorlist", { read: MatPaginator })
  paginatorlist: MatPaginator;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  SessionLoanSummary: any;
  @Input() FirstEMIDate: any;
  @Input() PLoanType: any;
  @Input() PageType: any;

  HiddenContent: boolean = false;
  today: Date = new Date();
  Cur_Date: any = new Date();
  printedByUser: string = "";
  AccHeadSummary: any[] = [];
  AccHeadDetails: any[] = [];
  ODDetails: any[] = [];
  DataSourceAccHeadD: any;
  EMIDetails: any;
  DisbursementDetails: any[] = [];
  IRR_CalculateBy: any;
  stepEMI: any[] = [];
  stepEmiData: any;
  LoanId: any;
  totalCRAmount: number = 0;
  totalDRAmount: number = 0;
  repaymentInstrument: any;
  SOAInfo: any;

  //viewAssetInfo
  Collateral_Type: any;
  Info: any;
  // Collateral: any;
  VehicleRegistationNo: any = "";
  AssetsAttachment: any = [];
  dataviewAssetItemSource: any;
  // dataAssetItemSource: any;
  ItemArr: any = [];
  VehicleKYC: any = [];
  RC_HPNEndorsment: any = "";
  Invoice_HPNEndorsment: any = "";
  // docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  // ApplicationNo: any = "";
  allCollateralData: any = [];
  ProcessHeadList: any[] = [];
  ChargesDataSource: any;


  constructor(
    private dataSharingService: DataSharingService,
    private _EncrDecrService: EncrDecrService,
    private snackBar: MatSnackBar,
    private router: Router,
    private losService: LosService,
    private _MasterService: MasterService,
    private reportsService: ReportsService,
    private dialog: DialogService,
    private lmsService: LmsService,
    private fb: UntypedFormBuilder,
    private _Partnerservice: PartnerService,
    private _commonfunctions: CommonFunctions
  ) { }

  ngOnInit() {
    // this.onSearchStatementDetail();
    if (this.isShowHeader) {
      this.dataSharingService.HeaderTitle.next("Loan Statement");
    }
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    console.log("currrentuserkanaaam", this.currentUser.username)

    this.getChargeshead();
    this.dropdownSettings = {
      singleSelection: false,
      idField: "Id",
      textField: "ChagesHead",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: this.ShowFilter,
    };
    this.myForm = this.fb.group({
      chargesHead: [],
    });
    this.ChargeHeadId = [{ Id: 34, ChagesHead: "Installment" }];
    this.displayedColumns = [
      "voucher_id",
      "Voucher_Date",
      "Voucher_No",
      "CaseNo",
      "Customer_Name",
      "accHead",
      "TranTypeDR",
      "TranTypeCR",
      "TranTypeTotal",
      "Narration",
      "ViewAction",
    ];
    this.displayedColumnsStatement = [
      "voucherid",
      "VoucherDate",
      "Voucher_No",
      "Receipt_No",
      "accHead",
      "TranTypeDR",
      "TranTypeCR",
      "TranTypeTotal",
      "Narration",
    ];
    this.displayedColumnsODCharges = [
      "HeadId",
      "ChagesHead",
      "TranTypeDR",
      "TranTypeCR",
      "TranTypeTotal",
      "Action",
    ];
    this.displayedColumnsOD = [
      //"voucherid", "VoucherDate", "Voucher_No",
      "voucherid",
      "VoucherDate",
      "Voucher_No",
      "OS_Balance",
      "DaysLate",
      "ODInterest",
      "ODCredit",
      "ODTotal",
    ];

    //This code for Loan Statment Page only
    if (JSON.parse(sessionStorage.getItem("LoanSummary"))) {
      this.SessionLoanSummary = JSON.parse(
        sessionStorage.getItem("LoanSummary")
      );
      //console.log("SessionLoanSummary : ",this.SessionLoanSummary);
      this.goToDetail(this.SessionLoanSummary);
    } else {
      sessionStorage.removeItem("LoanSummary");
    }

    this.getAllList();

    this.dataSharingService.getLmsViewLoanStatement().subscribe((res) => {
      if (res) {
        this.loanSummary = res;
        this.getAllList();
      }
    });

    if (this.PLoanType != undefined && this.PLoanType == "Partner") {
      //this.VoucherDateTo = new Date(this.FirstEMIDate);
      //console.log("this.FirstEMIDate :", this.FirstEMIDate);
    }

    // this.calculateTotal();
  }

  getAllList() {
    //console.log("this.loanSummary :", this.loanSummary);
    if (this.loanSummary == "" || this.loanSummary == undefined) {
      if (
        this.SessionLoanSummary != undefined ||
        this.SessionLoanSummary != ""
      ) {
        $("#SearchLoanDetailModel").modal("hide");
      } else {
        $("#SearchLoanDetailModel").modal("show");
        $("#SearchLoanDetailModel").css("z-index", "1050");
      }
    } else if (this.loanSummary.LoanNo) {
      this.ApplicationNo = this.loanSummary.ApplicationNo;
      this.LoanNo = this.loanSummary.LoanNo;
      //console.log("this.this.loanSummary :", this.loanSummary);
      this.lmsService
        .LMS_GetLoanDetails({ Loan_Id: this.loanSummary.LoanId })
        .subscribe((res: any) => {
          if (res.Item1.length > 0) {
            // console.log("res :", res.Item1[0]);
            this.showSpinner = false;
            this.ApplicationDetail = res.Item1[0];
            if (
              this.ApplicationDetail.EMIType == "Daily" ||
              this.ApplicationDetail.EMIType == "Weekly" ||
              this.ApplicationDetail.EMIType == "Fortnightly" ||
              this.ApplicationDetail.EMIType == "ByWeekly" ||
              this.ApplicationDetail.EMIType == "FourthWeekly" ||
              this.ApplicationDetail.EMIType == "SingleEMI"
            )
              this.TenureName = "Days";
            else this.TenureName = "Months";
            this.customerData = res.Item2;

            this.SourceAssets = res.Item6;
            this.showLess_LoanDetail = true;
            //this.showLoanOD = res.Item1[0].IsODDetail;
          }
        });

      this.showLoanODCharges = true;
      this.showLoanIncomeCharges = true;
      //var InterestDetail = <HTMLInputElement>(
      //  document.getElementById("InterestDetail")
      //);
      //InterestDetail.checked = true;

      var OtherDetail = <HTMLInputElement>(
        document.getElementById("OtherDetail")
      );
      OtherDetail.checked = true;

      //var incomeDetail = <HTMLInputElement>document.getElementById("incomeDetail");
      //incomeDetail.checked = true;
      this.onSearchStatementDetail();
    }
  }

  getChargeshead() {
    this._MasterService
      .GetProductChargesHeadDropDown()
      .subscribe((res: any) => {
        this.chargesHeadDropdown = res;
        //for (var i = 0; i < res.length; i++) {
        //  this.chargesHeadDropdown.push({ id: res[i]["Id"], name: res[i]["ChagesHead"]});
        //}
      });
  }
  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
    this.onSearchStatementDetail();
  }
  onSelectAll(items: any) {
    // console.log('onSelectAll', items);
    this.onSearchStatementDetail();
  }
  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, {
      allowSearchFilter: this.ShowFilter,
    });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, {
        limitSelection: 2,
      });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, {
        limitSelection: null,
      });
    }
  }
  onSearchStatementDetail() {
    //this.showSpinner = true;
    var VDate;
    // VDate = this.FirstEMIDate != undefined ? this.FirstEMIDate : this.VoucherDateTo;
    VDate = this.VoucherDateTo;
    //if (this.PLoanType != undefined && this.PLoanType == "Partner") {
    //  //this.VoucherDateTo = this.FirstEMIDate;
    //  this._Partnerservice
    //    .Partner_Get_ACC_Leadger_Loan_OD({
    //      LoanAcNo: this.LoanNo,
    //      ToDate: VDate,
    //    })
    //    .subscribe((res: any) => {
    //      if (res.length > 0) {
    //        console.log("OD RESPONSE", res);

    //        this.dataSourceLoanOD = new MatTableDataSource(
    //          JSON.parse(JSON.stringify(res))
    //        );
    //        this.dataSourceLoanOD.sort = this.sort;
    //        this.ODDetails = res;
    //        //this.dataSourceLoanOD.paginator= this.paginator;
    //        this.showSpinner = false;
    //      }
    //    });
    //} else {
    //  this.lmsService
    //    .Get_ACC_Leadger_Loan_OD({
    //      ApplicationNo: this.ApplicationNo,
    //      Loan_No: this.LoanNo,
    //      VoucherDate: VDate,
    //    })
    //    .subscribe((res: any) => {
    //      if (res.length > 0) {
    //        this.dataSourceLoanOD = new MatTableDataSource(
    //          JSON.parse(JSON.stringify(res))
    //        );
    //        this.dataSourceLoanOD.sort = this.sort;
    //        this.ODDetails = res;
    //        //this.dataSourceLoanOD.paginator= this.paginator;
    //        this.showSpinner = false;
    //      } else {
    //        this.dataSourceLoanOD = null;
    //        this.showSpinner = false;
    //      }
    //    });
    //}
    this.dataSourceLoan = null;
    this.onClickStatementDetail();
    this.lmsService
      .Get_Acc_Leadger_Loan({
        HeadId: 34,
        ApplicationNo: this.ApplicationNo,
        Loan_No: this.LoanNo,
        VoucherDate: VDate,
        Type: this.PLoanType,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          // console.log("Receipt No", this.FileCheckingList);
          this.dataSourceLoan = new MatTableDataSource(this.FileCheckingList);
          this.dataSourceLoan.sort = this.sort;
          //this.dataSourceLoan[this.FileCheckingList[0].HeadId].paginator = this.paginator;
          setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip();
          }, 1000);
          this.showSpinner = false;
        } else {
          this.dataSourceLoan = null;
        }
      });
    // this.getAccHeadDetails(this.ApplicationNo, this.LoanNo, VDate);
    //this.tableshow = true;
  }

  formatDate(dateString: string): string {
    const formattedDate = this.datePipe.transform(dateString, "dd-MMM-yy");
    return formattedDate || ""; // return empty string if datePipe returns null
  }

  onClickStatementDetail() {
    //this.showSpinner = true;
    var VDate;
    //VDate = this.FirstEMIDate != undefined ? this.FirstEMIDate : this.VoucherDateTo;
    VDate = this.VoucherDateTo;

    this.lmsService
      .Get_ACC_Leadger_Loan_OD_Charges({
        ApplicationNo: this.ApplicationNo,
        Loan_No: this.LoanNo,
        VoucherDate: VDate,
        SubType: this.PLoanType,
      })
      .subscribe((res: any) => {
        this.AccHeadSummary = res.Item1;
        this.dataSourceLoanODCharges = new MatTableDataSource(
          JSON.parse(JSON.stringify(res.Item1))
        );
        this.dataSourceLoanODCharges.sort = this.sort;
        //this.dataSourceLoanOD.paginator= this.paginator;
        this.dataSourceLoanIncomeCharges = new MatTableDataSource(
          JSON.parse(JSON.stringify(res.Item2))
        );
        this.dataSourceLoanIncomeCharges.sort = this.sort;
        this.showSpinner = false;
      });
    // this.getAccHeadDetails(this.ApplicationNo, this.LoanNo, VDate);
    //this.tableshow = true;
  }

  onCloseNachDetail() {
    $("#NachDetailModel").modal("hide");
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  onCloseSearchLoanDetail() {
    $("#SearchLoanDetailModel").modal("hide");
  }
  onSearchCustomerDetail() {
    this.Customer.LoginUserId = this.currentUser.userId;
    this._MasterService
      .Get_SearchCustomerByLMSLOS({ JSON: JSON.stringify(this.Customer) })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.displayedCustomerColumns = [
            "CustomerId",
            "Type",
            "Application_No",
            "LoanAcNo",
            "CustomertName",
            "FatherName",
            "Customer_Gender",
            "GenderAge",
            "PhoneNo",
            "EditAction",
          ];

          this.CustomerList = JSON.parse(JSON.stringify(res));
          if (this.Type != "0") {
            var type;
            if (this.Type == "1") type = "LOS";
            else type = "LMS";
            this.CustomerList = this.CustomerList.filter(
              (item) => item.Type == type
            );
          }
          this.dataSourceCustomer = new MatTableDataSource(this.CustomerList);
          this.dataSourceCustomer.sort = this.sort;
          this.dataSourceCustomer.paginator = this.paginator;
          this.showSpinner = false;
        }
      });
  }
  goToDetail(row) {
    this.onCloseSearchLoanDetail();
    //this.ApplicationNo = row.Application_No;
    //this.LoanNo = row.LoanAcNo;
    this.LoanId = row.LoanId;
    this.ApplicationNo = row.Application_No
      ? row.Application_No
      : row.ApplicationNo;
    this.LoanNo = row.LoanAcNo == undefined ? this.LoanNo : row.LoanAcNo;

    if (this.LoanNo == undefined) {
      this.LoanNo = row.LoanNo;
    }

    var OtherDetail = <HTMLInputElement>document.getElementById("OtherDetail");
    OtherDetail.checked = true;

    //var incomeDetail = <HTMLInputElement>document.getElementById("incomeDetail");
    //incomeDetail.checked = true;

    this.onSearchStatementDetail();

    this.lmsService
      .LMS_GetLoanDetails({ Loan_Id: row.LoanId })
      .subscribe((res: any) => {
        // console.log("res :", res);
        this.showSpinner = false;
        this.ApplicationDetail = res.Item1[0];
        //this.showLoanOD = res.Item1[0].IsODDetail;
        //var InterestDetail = <HTMLInputElement>(
        //  document.getElementById("InterestDetail")
        //);
        //InterestDetail.checked = this.showLoanOD;
        if (
          this.ApplicationDetail.EMIType == "Daily" ||
          this.ApplicationDetail.EMIType == "Weekly" ||
          this.ApplicationDetail.EMIType == "Fortnightly" ||
          this.ApplicationDetail.EMIType == "ByWeekly" ||
          this.ApplicationDetail.EMIType == "FourthWeekly" ||
          this.ApplicationDetail.EMIType == "SingleEMI"
        )
          this.TenureName = "Days";
        else this.TenureName = "Months";
        this.customerData = res.Item2;

        this.SourceAssets = res.Item6;
        this.EMIDetails = res.Item7[0];
        this.showLess_LoanDetail = true;
        this.showCustomerResult();
        this.showLess_FinanceDetail = true;
        // this.showLess_AssetsDetail = true;
        this.showAssetsResult();
        this.StepEmiDetail(row.LoanId);
        this.loadAllCollateralData(res.Item6);
      });

    this.lmsService
      .LMS_Get_DV_Details_Print({ LoanAcId: this.LoanId.toString() })
      .subscribe((res: any) => {
        this.showSpinner = false;
        console.log("LMS_Get_DV_Details_Print", res);
        this.ProcessHeadList = JSON.parse(JSON.stringify(res.Item3));
        this.ProcessHeadList.forEach((x) => {
          x.Deduction = 0;
          x.Receipt = 0;
          if (x.Type == "DR") x.Deduction = x.Amount;
          if (x.Type == "CR") x.Receipt = x.Amount;
          x.Total = x.Deduction + x.Receipt;
        });
        this.ChargesDataSource = new MatTableDataSource(this.ProcessHeadList);

      });
      this.callODChangeIfNeeded();
      const today = new Date();
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.reportsService
      .Report_MothlyDPD({
        LoanId: this.LoanId,
        ToDate: lastDay,
      })
      .subscribe((dpdRes: any) => {
        // If API returns a single object, wrap it in an array
        if (dpdRes && !Array.isArray(dpdRes)) {
          this.monthlyDPDList = [dpdRes];
        } else {
          this.monthlyDPDList = dpdRes || [];
        }
        // Set columns, filtering out unwanted keys
        if (this.monthlyDPDList.length > 0) {
          this.monthlyDPDColumns = Object.keys(this.monthlyDPDList[0]).filter(
            (key) => !this.monthlyDPDIgnoredKeys.includes(key)
          );
        } else {
          this.monthlyDPDColumns = [];
        }
      });
  }

  showResult() {
    this.showLess_LoanDetail = true;
  }
  hideResult() {
    this.showLess_LoanDetail = false;
  }
  showCustomerResult() {
    this.customerDataSource = new MatTableDataSource(this.customerData);
    this.showLess_CustomerDetail = true;
  }
  hideCustomerResult() {
    this.showLess_CustomerDetail = false;
    this.customerDataSource = new MatTableDataSource();
  }
  showFinanceResult() {
    this.showLess_FinanceDetail = true;
  }
  hideFinanceResult() {
    this.showLess_FinanceDetail = false;
  }
  showAssetsResult() {
    this.showLess_AssetsDetail = true;
    this.dataSourceAssets = new MatTableDataSource(this.SourceAssets);
  }

  hideAssetsResult() {
    this.showLess_AssetsDetail = false;
    this.dataSourceAssets = new MatTableDataSource();
  }
  callODChangeIfNeeded() {
    if ((this.soaSections.odDetail = true)) {
      this.showLoanOD = true;
      // Fetch OD details as in ODChange
      if (this.PLoanType != undefined && this.PLoanType == "Partner") {
        this._Partnerservice
          .Partner_Get_ACC_Leadger_Loan_OD({
            LoanAcNo: this.LoanNo,
            ToDate: this.VoucherDateTo,
          })
          .subscribe((res: any) => {
            if (res.length > 0) {
              this.dataSourceLoanOD = new MatTableDataSource(res);
              this.dataSourceLoanOD.sort = this.sort;
              this.ODDetails = res;
              this.showSpinner = false;
            }
          });
      } else {
        this.lmsService
          .Get_ACC_Leadger_Loan_OD({
            ApplicationNo: this.ApplicationNo,
            Loan_No: this.LoanNo,
            VoucherDate: this.VoucherDateTo,
          })
          .subscribe((res: any) => {
            if (res.length > 0) {
              this.dataSourceLoanOD = new MatTableDataSource(res);
              this.dataSourceLoanOD.sort = this.sort;
              this.ODDetails = res;
              this.showSpinner = false;
            } else {
              this.dataSourceLoanOD = null;
              this.showSpinner = false;
            }
          });
      }
    }
  }

  ODChange(event) {
    if (event.srcElement.checked == true) {
      this.showLoanOD = true;
      if (this.PLoanType != undefined && this.PLoanType == "Partner") {
        //this.VoucherDateTo = this.FirstEMIDate;
        this._Partnerservice
          .Partner_Get_ACC_Leadger_Loan_OD({
            LoanAcNo: this.LoanNo,
            ToDate: this.VoucherDateTo,
          })
          .subscribe((res: any) => {
            if (res.length > 0) {
              // console.log("OD RESPONSE", res);

              this.dataSourceLoanOD = new MatTableDataSource(
                JSON.parse(JSON.stringify(res))
              );
              this.dataSourceLoanOD.sort = this.sort;
              this.ODDetails = res;
              //this.dataSourceLoanOD.paginator= this.paginator;
              this.showSpinner = false;
            }
          });
      } else {
        this.lmsService
          .Get_ACC_Leadger_Loan_OD({
            ApplicationNo: this.ApplicationNo,
            Loan_No: this.LoanNo,
            VoucherDate: this.VoucherDateTo,
          })
          .subscribe((res: any) => {
            if (res.length > 0) {
              this.dataSourceLoanOD = new MatTableDataSource(
                JSON.parse(JSON.stringify(res))
              );
              this.dataSourceLoanOD.sort = this.sort;
              this.ODDetails = res;
              //this.dataSourceLoanOD.paginator= this.paginator;
              this.showSpinner = false;
            } else {
              this.dataSourceLoanOD = null;
              this.showSpinner = false;
            }
          });
      }
    } else this.showLoanOD = false;
  }

  ChargesChange(event) {
    if (event.srcElement.checked == true) {
      //this.onClickStatementDetail();
      this.showLoanODCharges = true;
      this.showLoanIncomeCharges = true;
    } else {
      this.showLoanODCharges = false;
      this.showLoanIncomeCharges = false;
    }
  }

  IncomeChargesChange(event) {
    if (event.srcElement.checked == true) this.showLoanIncomeCharges = true;
    else this.showLoanIncomeCharges = false;
  }

  goToChargesDetail(row) {
    this.showSpinner = true;
    this.ROW = row;
    this.FileCheckingList = [];
    this.lmsService
      .Get_Acc_Leadger_Loan_Charges_Detail({
        HeadId: row.HeadId,
        ApplicationNo: this.ApplicationNo,
        Loan_No: this.LoanNo,
        VoucherDate: this.VoucherDateTo,
        SubType: this.PLoanType,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.ChargesJson = res;
          this.dataSourceChargesDetail = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.dataSourceChargesDetail.sort = this.sort;
          this.dataSourceChargesDetail.paginator = this.paginatorlist;
          //this.dataSourceLoan[this.FileCheckingList[0].HeadId].paginator = this.paginator;
          setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip();
          }, 1000);
          this.showSpinner = false;
          this.ChargesName = row.ChagesHead;
          $("#ChargesLoanDetailModel").modal("show");
          $("#ChargesLoanDetailModel").css("z-index", "1050");
        } else {
          this.dataSourceChargesDetail = null;
          $("#ChargesLoanDetailModel").modal("hide");
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No Data Found!!!",
            ...this.configSuccess,
          });

          this.showSpinner = false;
        }
      });
  }
  onCloseChargesLoanDetail() {
    this.ChargesName = "";
    $("#ChargesLoanDetailModel").modal("hide");
  }
  calculateODTotal() {
    if (this.dataSourceLoanOD != null) {
      let sum = 0;
      let DR = this.calculateODInterest();
      let CR = this.calculateODCredit();
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }
    return 0;
  }
  calculateODInterest() {
    if (this.dataSourceLoanOD != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSourceLoanOD.filteredData.length; i++) {
        sum += Number(this.dataSourceLoanOD.filteredData[i]["ODDebit"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  calculateODDays() {
    if (this.dataSourceLoanOD != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSourceLoanOD.filteredData.length; i++) {
        sum += Number(this.dataSourceLoanOD.filteredData[i]["DaysLate"]);
      }
      return sum;
    }
    return 0;
  }

  calculateODCredit() {
    if (this.dataSourceLoanOD != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSourceLoanOD.filteredData.length; i++) {
        sum += Number(this.dataSourceLoanOD.filteredData[i]["ODCredit"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateChargesDR() {
    if (this.dataSourceChargesDetail != null) {
      let sum = 0.0;
      for (
        let i = 0;
        i < this.dataSourceChargesDetail.filteredData.length;
        i++
      ) {
        sum += Number(
          this.dataSourceChargesDetail.filteredData[i]["TranTypeDR"]
        );
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateChargesCR() {
    if (this.dataSourceChargesDetail != null) {
      let sum = 0.0;
      for (
        let i = 0;
        i < this.dataSourceChargesDetail.filteredData.length;
        i++
      ) {
        sum += Number(
          this.dataSourceChargesDetail.filteredData[i]["TranTypeCR"]
        );
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateChargesTotal() {
    if (this.dataSourceChargesDetail != null) {
      let sum = 0;
      let DR = this.calculateChargesDR();
      let CR = this.calculateChargesCR();
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }
    return 0;
  }
  calculateChargesTranTypeTotal(Type) {
    if (this.dataSourceLoanODCharges != null && Type == "OD") {
      let sum = 0;
      let DR = this.calculateChargesTranTypeDR("OD");
      let CR = this.calculateChargesTranTypeCR("OD");
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }
    if (this.dataSourceLoanIncomeCharges != null && Type == "ID") {
      let sum = 0;
      let DR = this.calculateChargesTranTypeDR("ID");
      let CR = this.calculateChargesTranTypeCR("ID");
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }
    return 0;
  }
  calculateChargesTranTypeCR(Type) {
    if (this.dataSourceLoanODCharges != null && Type == "OD") {
      let sum = 0.0;
      for (
        let i = 0;
        i < this.dataSourceLoanODCharges.filteredData.length;
        i++
      ) {
        sum += Number(
          this.dataSourceLoanODCharges.filteredData[i]["TranTypeCR"]
        );
      }
      return sum.toFixed(2);
    }
    if (this.dataSourceLoanIncomeCharges != null && Type == "ID") {
      let sum = 0.0;
      for (
        let i = 0;
        i < this.dataSourceLoanIncomeCharges.filteredData.length;
        i++
      ) {
        sum += Number(
          this.dataSourceLoanIncomeCharges.filteredData[i]["TranTypeCR"]
        );
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  calculateChargesTranTypeDR(Type) {
    if (this.dataSourceLoanODCharges != null && Type == "OD") {
      let sum = 0.0;
      for (
        let i = 0;
        i < this.dataSourceLoanODCharges.filteredData.length;
        i++
      ) {
        sum += Number(
          this.dataSourceLoanODCharges.filteredData[i]["TranTypeDR"]
        );
      }
      return sum.toFixed(2);
    }
    if (this.dataSourceLoanIncomeCharges != null && Type == "ID") {
      let sum = 0.0;
      for (
        let i = 0;
        i < this.dataSourceLoanIncomeCharges.filteredData.length;
        i++
      ) {
        sum += Number(
          this.dataSourceLoanIncomeCharges.filteredData[i]["TranTypeDR"]
        );
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  calculateTranTypeDR() {
    if (this.dataSourceLoan != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSourceLoan.filteredData.length; i++) {
        sum += Number(this.dataSourceLoan.filteredData[i]["TranTypeDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateTranTypeCR() {
    if (this.dataSourceLoan != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSourceLoan.filteredData.length; i++) {
        sum += Number(this.dataSourceLoan.filteredData[i]["TranTypeCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateTranTypeTotal() {
    if (this.dataSourceLoan != null) {
      let sum = 0;
      let DR = this.calculateTranTypeDR();
      let CR = this.calculateTranTypeCR();
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }
    return 0;
  }
  onCloseVoucherDetail() {
    $("#VoucherDetail").modal("hide");
  }
  ViewVoucherDetail(row) {
    $("#VoucherDetail").modal("show");
    $("#VoucherDetail").css("z-index", "1050");

    this.lmsService
      .LMS_Get_Voucher_Details({ VoucherId: row.voucherid })
      .subscribe((res: any) => {
        //console.log("res", res);
        this.voucherModel.Voucher = res.Item1[0];
        this.voucherModel.Voucher_Detail = res.Item2;
        if (
          this.voucherModel.Voucher.Voucher_Type == "Receipt" ||
          this.voucherModel.Voucher.Voucher_Type == "Journal" ||
          this.voucherModel.Voucher.Voucher_Type == "Payment"
        )
          this.ShowDelete = true;
        else this.ShowDelete = false;
        this.voucherModel.Voucher_Detail.forEach((x) => {
          x.AmountDR = 0.0;
          x.AmountCR = 0.0;
          if (x.TranType == "CR") x.AmountCR = x.Amount;
          if (x.TranType == "DR") x.AmountDR = x.Amount;
        });
        if (
          this.voucherModel.Voucher.Voucher_Mode_of_Payment == "" ||
          this.voucherModel.Voucher.Voucher_Mode_of_Payment == null
        )
          this.voucherModel.Voucher.Voucher_Mode_of_Payment = "CASH";
        // this.onVoucherTagChange();
      });
  }

  // getAssetDetail(data: any, isEdit: boolean) {
  //   if (data.Collateral == "Vehicle") {
  //     this.LMS_GetAssetsDetailVehicle(data.AssetId, data.Collateral);
  //   } else if (data.Collateral == "Property") {
  //     this.LMS_Get_AssetsDetail_Property(data.AssetId, data.Collateral);
  //   } else if (data.Collateral == "Gold") {
  //     this.LMS_GetAssetsDetailGOLD(data.AssetId, data.Collateral);
  //   }
  //   //else if (data.Collateral == 'Consumer Durable') {
  //   //  this.LMS_GetAssetsDetailConsumerDurable();
  //   //}
  // }
  // LMS_GetAssetsDetailVehicle(AssetId, Collateral_Type) {
  //   this.showSpinner = true;
  //   this.lmsService
  //     .ViewAssetInfo({ SearchBy: Collateral_Type, Id: AssetId })
  //     .subscribe((res: any) => {
  //       this.showSpinner = false;
  //       this.assetModel = res.Item1[0];
  //       this.assetModel.Collateral = "Vehicle";
  //       this.assetModel.MefgYear = this.assetModel.MefgYear; //new Date(this.assetModel.MefgYear);
  //       if (this.assetModel.RegistationDate) {
  //         this.assetModel.RegistationDate = new Date(
  //           this.assetModel.RegistationDate
  //         );
  //       }
  //       if (this.assetModel.RegistationExpiryDate) {
  //         this.assetModel.RegistationExpiryDate = new Date(
  //           this.assetModel.RegistationExpiryDate
  //         );
  //       }
  //       if (this.assetModel.RoadTaxUpto) {
  //         this.assetModel.RoadTaxUpto = new Date(this.assetModel.RoadTaxUpto);
  //       }
  //       if (this.assetModel.FitnessUpto) {
  //         this.assetModel.FitnessUpto = new Date(this.assetModel.FitnessUpto);
  //       }
  //       if (this.assetModel.PermitUpto) {
  //         this.assetModel.PermitUpto = new Date(this.assetModel.PermitUpto);
  //       }
  //       if (this.assetModel.InvoiceDate) {
  //         this.assetModel.InvoiceDate = new Date(this.assetModel.InvoiceDate);
  //       }
  //       if (this.assetModel.ValuationDate) {
  //         this.assetModel.ValuationDate = new Date(
  //           this.assetModel.ValuationDate
  //         );
  //       }
  //       //this.GetManufactureForDropdown();
  //       //this.GetVehicleCategoryForDropdown(false);
  //       //this.GetVehicleModelForDropdown(false);
  //       //this.getFuelType();
  //       //this.LOS_GetApplicatonCustomer();
  //       //this.Get_PartnerForDropdown();
  //       //this.GetEmployeeDropdown();
  //       $("#assetModel").modal("show");
  //       $("#assetModel").css("z-index", "1050");
  //     });
  // }
  // LMS_Get_AssetsDetail_Property(AssetId, Collateral_Type) {
  //   this.showSpinner = true;
  //   this.lmsService
  //     .ViewAssetInfo({ SearchBy: Collateral_Type, Id: AssetId })
  //     .subscribe((res: any) => {
  //       this.showSpinner = false;
  //       this.assetModel = res.Item1[0];
  //       this.assetModel.Collateral = "Property";
  //       if (this.assetModel.GeoLocation) {
  //         let _loc = this.assetModel.GeoLocation.split(",");
  //         if (_loc[0]) {
  //           this.assetModel.Latitude = _loc[0];
  //         }
  //         if (_loc[1]) {
  //           this.assetModel.Longitude = _loc[1];
  //         }
  //       }
  //       //this.LOS_GetApplicatonCustomer();
  //       //this.GetStateDropdown();
  //       //this.GetEmployeeDropdown();
  //       //this.GetDistrickDropdown(false);
  //       //this.GetTehasilDropdown(false);
  //       $("#assetModel").modal("show");
  //       $("#assetModel").css("z-index", "1050");
  //     });
  // }
  // LMS_GetAssetsDetailGOLD(AssetId, Collateral_Type) {
  //   this.showSpinner = true;
  //   this.lmsService
  //     .ViewAssetInfo({ SearchBy: Collateral_Type, Id: AssetId })
  //     .subscribe((res: any) => {
  //       this.showSpinner = false;
  //       this.assetModel = res.Item1[0];
  //       if (this.assetModel.ValuationDate) {
  //         this.assetModel.ValuationDate = new Date(
  //           this.assetModel.ValuationDate
  //         );
  //       }
  //       this.assetModel.Collateral = "Gold";
  //       //this.GetEmployeeDropdown();
  //       this.assetModel.Item = {};
  //       this.assetModel.ItemArr = res.Item2;
  //       this.displayedAssetItemColumns = [
  //         "Id",
  //         "ItemName",
  //         "ItemType",
  //         "Qty",
  //         "PurityCT",
  //         "GrossWt",
  //         "StoneWt",
  //         "OtherWt",
  //         "ValulationRate_PerCT",
  //         "ValulationAmount",
  //       ];
  //       this.dataAssetItemSource = new MatTableDataSource(
  //         this.assetModel.ItemArr
  //       );
  //       this.getAssetTotal();
  //       $("#assetModel").modal("show");
  //       $("#assetModel").css("z-index", "1050");
  //     });
  // }
  ViewData(row) {
    this.lmsService.ViewAssetInfo({
      SearchBy: row.Collateral,
      Id: row.AssetId,
    }).subscribe((response: any) => {
      // console.log("response :", response);
      this.Collateral = row.Collateral;
      this.Collateral_Type = row.Collateral_Type;
      this.Info = response.Item1[0];
      // this.SOAInfo = response.Item1;
      console.log("View data api call---View Info", this.Info);
      console.log("View data api call---View Info", this.SOAInfo);
      this.AssetsAttachment = response.Item2;
      this.RC_HPNEndorsment = response.Item1[0].RC_HPNEndorsment;
      this.Invoice_HPNEndorsment = response.Item1[0].Invoice_HPNEndorsment;

      if (this.Collateral == "Gold") {
        this.dataviewAssetItemSource = new MatTableDataSource(response.Item3);
        this.dataAssetItemSource = new MatTableDataSource(response.Item3);
        this.ItemArr = response.Item3;
      }
      if (this.Info.VehicleRegistationNo) {
        this.VehicleRegistationNo = this.Info.VehicleRegistationNo;
        // this.Get_Alredy_Verified_KYC();
      }
      $("#View").modal("show");
      $("#View").css("z-index", "1050");
    });
  }
  onCloseView() {
    $("#View").modal("hide");
  }
  onClosePrimaryAsset() {
    $("#assetModel").modal("hide");
  }
  getAssetTotal() {
    if (this.assetModel.ItemArr.length == 0) {
      this.assetTotal = undefined;
    } else {
      this.assetTotal = {
        Qty: this.assetModel.ItemArr.length,
        GrossWt: 0,
        StoneWt: 0,
        OtherWt: 0,
      };
      this.assetModel.ItemArr.forEach((obj: any) => {
        this.assetTotal.GrossWt += obj.GrossWt;
        this.assetTotal.StoneWt += obj.StoneWt;
        this.assetTotal.OtherWt += obj.OtherWt;
      });
    }
  }

  //LMS_GetAssetsDetailConsumerDurable() {
  //  this.showSpinner = true;
  //  this.losService
  //    .LOS_GetAssetsDetailConsumerDurable({
  //      AssetId: this.selectedAsset.AssetId
  //    })
  //    .subscribe((res: any) => {
  //      this.showSpinner = false;
  //      this.assetModel = res.Item1[0];
  //      //   this.GetEmployeeDropdown();
  //      this.assetModel.Collateral = 'Consumer Durable';
  //      this.assetModel.Item = {};
  //      this.assetModel.ItemArr = res.Item2;
  //      this.displayedAssetItemColumns = [
  //        "Id",
  //        "ItemCategory",
  //        "ItemName",
  //        "ItemMake",
  //        "ItemQty",
  //        "ItemSeralNo",
  //        "Amount",
  //        "Remark",
  //        "OtherWt",
  //        "ValulationRate_PerCT",
  //        "ValulationAmount",
  //        "Action"
  //      ];
  //      this.dataAssetItemSource = new MatTableDataSource(this.assetModel.ItemArr);
  //      $('#assetModel').modal('show');
  //      $("#assetModel").css("z-index", "1050");
  //    });
  //}
  DateChange() {
    this.FirstEMIDate = undefined;
    this.showLoanOD = false;
    var InterestDetail = <HTMLInputElement>(
      document.getElementById("InterestDetail")
    );
    InterestDetail.checked = false;
    this.onSearchStatementDetail();
  }
  DeleteVoucher() {
    this.dialog
      .openConfirmDialog(`Are you sure you want to remove this Voucher.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.lmsService
            .Delete_Voucher({
              VoucherId: this.voucherModel.Voucher.VoucherId,
              LoginUserId: this.currentUser.userId,
            })
            .subscribe((res: any) => {
              if (res[0].CODE == 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                if (
                  this.voucherModel.Voucher_Detail.find((obj: any) => {
                    return obj.ChargeHeadId == 34;
                  })
                )
                  this.lmsService
                    .LMS_Update_EMI_Allocation({
                      VoucherId: this.voucherModel.Voucher.VoucherId,
                    })
                    .subscribe((res1: any) => { });

                this.onCloseVoucherDetail();
                this.onCloseChargesLoanDetail();
                this.onSearchStatementDetail();
              }
            });
        }
      });
  }

  calculateVoucherTranTypeDR() {
    if (this.voucherModel.Voucher_Detail != null) {
      let sum = 0.0;
      for (let i = 0; i < this.voucherModel.Voucher_Detail.length; i++) {
        sum += Number(this.voucherModel.Voucher_Detail[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateVoucherTranTypeCR() {
    if (this.voucherModel.Voucher_Detail != null) {
      let sum = 0.0;
      for (let i = 0; i < this.voucherModel.Voucher_Detail.length; i++) {
        sum += Number(this.voucherModel.Voucher_Detail[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  //GetData(data) {
  //  if (data == true) {
  //    this.onCloseChargesLoanDetail();
  //    this.onSearchStatementDetail();
  //  }
  //}
  GetData(data) {
    if (data.status == true) {

      //this.onCloseChargesLoanDetail();
      this.goToChargesDetail(data.ROW);
      this.onSearchStatementDetail();
    }
  }
  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Charges-Details`,
      sheet: "Charges-Details",
    });
  }
  exportTableODDetail(exporter1: any) {
    exporter1.exportTable("xls", {
      fileName: `OD-Details`,
      sheet: "OD-Details",
    });
  }

  datePipe: DatePipe = new DatePipe("en-US");

  onPrint(divName, type) {
    var File_Name;
    File_Name = type == 1 ? "loan-statement.pdf" : "SOA.pdf";
    this.HiddenContent = true;
    let DATA: any = document.getElementById(divName);
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      canvas.getContext("webgl");
      const FILEURI = canvas.toDataURL("image/jpg");
      let PDF = new jsPDF("p", "mm", "a4");
      let position = 30;

      var pageHeight = PDF.internal.pageSize.getHeight();
      var pagecount = Math.ceil(fileHeight / pageHeight);
      //console.log(pagecount);
      PDF.addImage(FILEURI, "JPEG", 1, position, fileWidth, 0);

      if (pagecount > 0) {
        var j = 1;
        while (j != pagecount) {
          PDF.addPage("p");
          PDF.addImage(FILEURI, "JPEG", 2, -(j * pageHeight), fileWidth - 4, 0);
          j++;
        }
      }

      PDF.setFontSize(8);
      PDF.setTextColor(33, 37, 41);
      PDF.text(this.currentUser.CompanyName, 3, 20);
      PDF.text("Printed By : " + this.currentUser.username, 3, 285);
      PDF.text(
        "Printed On : " +
        this.datePipe.transform(new Date(), "dd/MM/yyyy hh:mm:ss"),
        160,
        285
      );
      PDF.save(File_Name);
    });
  }

  ViewSOA() {
    $("#SOAModel").modal("show");
    $("#SOAModel").css("z-index", "1050");
  }
  onCloseSOAModel() {
    $("#SOAModel").modal("hide");
  }

  openNewWindow(data) {
    this.router.navigate([
      `/print/${encodeURIComponent(
        this._EncrDecrService.encrypt(data.Loan_Id)
      )}`,
    ]);
  }

  totaltypewise(type) {
    if (
      this.DataSourceAccHeadD != null &&
      this.DataSourceAccHeadD != undefined &&
      this.DataSourceAccHeadD != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.DataSourceAccHeadD.filteredData.length; i++) {
        sum += Number(this.DataSourceAccHeadD.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  totaltypeAccountwise() {
    if (
      this.DataSourceAccHeadD != null &&
      this.DataSourceAccHeadD != undefined &&
      this.DataSourceAccHeadD != ""
    ) {
      let sum = 0;
      let DR = this.totaltypewise("TranTypeDR");
      let CR = this.totaltypewise("TranTypeCR");
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }

    return 0;
    //if (
    //  this.DataSourceAccHeadD != null &&
    //  this.DataSourceAccHeadD != undefined &&
    //  this.DataSourceAccHeadD != ""
    //) {
    //  let sum = 0;
    //  for (let i = 0; i < this.DataSourceAccHeadD.filteredData.length; i++) {
    //    sum += Number(this.DataSourceAccHeadD.filteredData[i][type]);
    //  }
    //  return sum > 0 ? sum.toFixed(2) : 0;
    //}
    //return 0;
  }

  getAccHeadDetails(ApplicationNo, LoanNo, VDate) {
    this.lmsService
      .Get_ACC_LeadgerLoancharges_For_print({
        ApplicationNo: ApplicationNo,
        LoanAcNo: LoanNo,
        To: VDate,
        IsLoanStock: this.soaSections.IncludingStock ? 1 : 0,
        IsOtherCharges: this.soaSections.OtherDues ? 1 : 0,
        IsDVVoucher: this.soaSections.DVVoucher ? 1 : 0,
      })
      .subscribe((res: any) => {
        this.AccHeadDetails = res;
        this.DataSourceAccHeadD = new MatTableDataSource(
          JSON.parse(JSON.stringify(res))
        );
      });
  }

  onDocsPrint(divName, Header) {
    this._commonfunctions.PrintDocuments(
      divName,
      Header,
      this.ApplicationDetail.LoanAcNo
    );
  }

  StepEmiDetail(LoanId) {
    this.lmsService
      .FinancialDetailsForUpdate({ Loan_Id: LoanId })
      .subscribe((res: any) => {
        this.IRR_CalculateBy = res.Item1[0].IRR_CalculateBy;
        res.Item2.forEach((obj: any) => {
          this.stepEMI.push({
            FromEMI: obj.FromEMI,
            ToEMI: obj.ToEMI,
            EMI_Amount: obj.EMIAmount,
            NoOfInstl: obj.NoOfEMI,
            TotalAmount: obj.TotalAmount,
            EMIAmountPrint: obj.EMIAmountPrint,
          });
        });
        this.getTotlaStepEmiAndAmount();
      });
  }

  getTotlaStepEmiAndAmount() {
    let TotalEmi: any = 0,
      TotalAmount: any = 0;
    for (let i = 0; i < this.stepEMI.length; i++) {
      if (this.stepEMI[i].EMI_Amount) {
        TotalEmi =
          TotalEmi + (+this.stepEMI[i].ToEMI - +this.stepEMI[i].FromEMI + 1);
        TotalAmount =
          TotalAmount +
          (+this.stepEMI[i].ToEMI - +this.stepEMI[i].FromEMI + 1) *
          +this.stepEMI[i].EMI_Amount;
      }
    }
    this.stepEmiData = { totalEmi: TotalEmi, totalAmount: TotalAmount };
  }

  // Excel export in backend start here
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    //this.saveAsExcelFile(excelBuffer, excelFileName);

    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      excelFileName + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ExportExcel() {
    let JsonData = this.FileCheckingList;
    JsonData.forEach((obj: any) => {
      delete obj.voucherid;
      delete obj.ChagesHead;
      delete obj.Voucher_Type;
      delete obj.HeadId;
      delete obj.DaysLate;
      delete obj.ODInterest;
      delete obj.ODCredit;
      delete obj.ODTotal;
      delete obj.Balance;
      delete obj.Customer_Name;
      delete obj.Voucher_Cheque_Clear_Date;

      obj.TotalBalance = obj.TranTypeTotal;

      delete obj.TranTypeTotal;
    });

    JsonData.push({
      VoucherDate: "",
      Voucher_No: "",
      CaseNo: "",
      accHead: "Total",
      TranTypeDR: this.calculateTranTypeDR(),
      TranTypeCR: this.calculateTranTypeCR(),
      TotalBalance: this.calculateTranTypeTotal(),
      Narration: "",
    });
    this.exportAsExcelFile(JsonData, "Loan-Statement");
  }
  ExportExcelCharges() {
    this.ChargesJson.forEach((obj: any) => {
      delete obj.voucherid;
      delete obj.ChagesHead;
      delete obj.Voucher_Type;
      delete obj.HeadId;
      delete obj.DaysLate;
      delete obj.ODInterest;
      delete obj.ODCredit;
      delete obj.ODTotal;
      delete obj.Balance;
      delete obj.Voucher_Cheque_Clear_Date;

      obj.TotalBalance = obj.TranTypeTotal;

      delete obj.TranTypeTotal;
    });
    this.exportAsExcelFile(this.ChargesJson, "Charges Details");
  }
  // Excel export in backend code end here

  //exportexcelNew() {
  //  debugger;
  //  /* pass here the table id */
  //  let element = document.getElementById('excel-table');
  //  element.style.backgroundColor = "var(--theme-primary)";
  //  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

  //  /* generate workbook and add the worksheet */
  //  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  // // ws.Sheets.Sheet1.A1.s = { font: { bold: true } };
  //  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //  /* save to file */
  //  XLSX.writeFile(wb, 'Statement.xlsx');

  //}
  toggleSOASelectAll() {
    for (const section of this.soaSectionList) {
      this.soaSections[section.key] = this.soaSelectAll;
    }
  }
  toggleStatementSelectAll() {
    for (const section of this.statementSectionsList) {
      this.statementSections[section.key] = this.StatementSelectAll;
    }
  }
  statementSectionsList = [
    { key: "loanDetail", label: "Loan Detail" },
    { key: "customerDetail", label: "Customer Detail" },
    { key: "financeDetail", label: "Finance Detail" },
    { key: "emiDetail", label: "EMI Detail" },
    { key: "accountSummary", label: "Account Summary" },
    { key: "installmentDetail", label: "Installment Detail" },
    { key: 'disbursementDetail', label: 'Disbursement Detail' },

  ];
  soaSectionList = [
    { key: "loanDetail", label: "Loan Detail" },
    { key: "customerDetail", label: "Customer Detail" },
    { key: "financeDetail", label: "Finance Detail" },
    { key: "emiDetail", label: "EMI Detail" },
    { key: "accountSummary", label: "Account Summary" },
    { key: "IncludingStock", label: "Including Stock " },
    { key: "OtherDues", label: "Other Dues" },
    { key: "DVVoucher", label: "DV Voucher" },
    { key: "odDetail", label: "OD Details" },
    { key: "monthlyDPD", label: "Monthly DPD" },
    { key: "InstrumentsClear", label: "Repayment Instruments Clear" },
    { key: "InstrumentsBounce", label: "Repayment Instruments Bounce" },
    { key: "AssetsDetail", label: "Asset Detail" },
    { key: 'disbursementDetail', label: 'Disbursement Detail' },
  ];

  openSOASectionSelectModal() {
    ($("#SOASectionSelectModal") as any).modal("show");
    this.updateFilteredSOASectionList()

  }
  closeSOASectionSelectModal() {
    ($("#SOASectionSelectModal") as any).modal("hide");
  }
  openSOAModalWithSelection() {
    this.closeSOASectionSelectModal();
    this.LoanSOAPrint();
  }
  openStatementSectionSelectModal() {
    ($("#StatementSectionSelectModal") as any).modal("show");
    this.updateFilteredStatementSectionList()

  }
  closeStatementSectionSelectModal() {
    ($("#StatementSectionSelectModal") as any).modal("hide");
  }
  openStatementModalWithSelection() {
    this.closeStatementSectionSelectModal();
    // this.LoanSOAPrint();
    this.LoanStatementPrint();
  }
  exportexcelNew() {
    this.printedByUser = this.currentUser.FullName;
    setTimeout(() => {
      this._commonfunctions.exportHtmlTableToExcel(
        "excel-table",
        `LoanStatement_${this.ApplicationDetail ? this.ApplicationDetail.LoanAcNo : "Report"}.xls`,
        "LoanStatement"
      );
    }, 0);
  }
  onCloseLoanStatementPrintModel() {
    $("#LoanStatementPrintModel").modal("hide");
  }

  onCloseLoanSOAPrintModel() {
    $("#LoanSOAPrintModel").modal("hide");
  }
  updateFilteredSOASectionList() {
    console.log(this.soaSectionList)
    this.filteredSOASectionList = this.soaSectionList.filter(section => {
      switch (section.key) {
        case 'loanDetail':
          return !!this.ApplicationDetail;
        case 'customerDetail':
          return !!this.customerData?.length;
        case 'financeDetail':
          return !!this.ApplicationDetail;
        case 'emiDetail':
          return !!this.EMIDetails;
        case 'accountSummary':
          return !!this.AccHeadSummary?.length;
        case 'accountDetail':
          return !!this.AccHeadDetails?.length;
        case 'IncludingStock':
          return !!this.AccHeadSummary?.length;
        case 'OtherDues':
          return !!this.FileCheckingList?.length;
        case 'DVVoucher':
          return !!this.AccHeadSummary?.length;
        case 'odDetail':
          return !!this.ODDetails?.length;
        case 'monthlyDPD':
          return !!this.monthlyDPDList?.length;
        case 'InstrumentsClear':
          return !!this.repaymentInstrumentsClear?.length;
        case 'InstrumentsBounce':
          return !!this.repaymentInstrumentsBounce?.length;
        case 'AssetsDetail':
          return !!this.SourceAssets?.length;
        case 'disbursementDetail':
          return !!this.ProcessHeadList?.length;
        default:
          return false;
      }
    });
    console.log(this.filteredSOASectionList);
  }
  updateFilteredStatementSectionList() {
    console.log(this.statementSectionsList)
    this.filteredStatementSectionList = this.statementSectionsList.filter(section => {
      switch (section.key) {
        case 'loanDetail':
          return !!this.ApplicationDetail;
        case 'customerDetail':
          return !!this.customerData?.length;
        case 'financeDetail':
          return !!this.ApplicationDetail;
        case 'emiDetail':
          return !!this.EMIDetails;
        case 'accountSummary':
          return !!this.AccHeadSummary?.length;
        case 'installmentDetail':
          return !!this.FileCheckingList?.length;
        case 'disbursementDetail':
          return !!this.ProcessHeadList?.length;

        default:
          return false;
      }
    });
    console.log(this.filteredStatementSectionList);
  }

  //   loadAllCollateralData(collateralList: any[]) {
  //   this.allCollateralData = [];

  //   if (!collateralList || collateralList.length === 0) return;

  //   // Fetch data for each collateral
  //   collateralList.forEach((collateral, index) => {
  //     this.lmsService.ViewAssetInfo({
  //       SearchBy: collateral.Collateral,
  //       Id: collateral.AssetId,
  //     }).subscribe((response: any) => {
  //       // Store each collateral's data with its index
  //       const collateralData = {
  //         index: index,
  //         collateral: collateral.Collateral,
  //         data: response.Item1,
  //         assetsAttachment: response.Item2,
  //         itemArr: response.Item3
  //       };

  //       this.allCollateralData.push(collateralData);

  //       // If this is the first collateral, set SOAInfo for initial display
  //       if (index === 0) {
  //         this.SOAInfo = response.Item1;
  //       }
  //     });
  //   });
  // }
  loadAllCollateralData(collateralList: any[]) {
    this.allCollateralData = [];

    if (!collateralList || collateralList.length === 0) return;

    // Keep track of completed requests
    const requestsCompleted = [];

    // Fetch data for each collateral
    collateralList.forEach((collateral, index) => {
      this.lmsService.ViewAssetInfo({
        SearchBy: collateral.Collateral,
        Id: collateral.AssetId,
      }).subscribe((response: any) => {
        // Store each collateral's data with its index
        const collateralData = {
          index: index,
          collateral: collateral.Collateral,
          data: response.Item1,
          assetsAttachment: response.Item2,
          itemArr: response.Item3
        };

        this.allCollateralData.push(collateralData);
        requestsCompleted.push(index);


        this.allCollateralData.sort((a, b) => a.index - b.index);

        if (index === 0 && !this.SOAInfo) {
          this.SOAInfo = response.Item1;
        }
        if (!this.SOAInfo && this.allCollateralData.length > 0) {
          this.SOAInfo = this.allCollateralData[0].data;
        }
      });
    });
  }
  LoanSOAPrint() {
    const today = new Date();
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    // this.soaSections.odDetail ? this.callODChangeIfNeeded() : "";
    

        this.lmsService
          .LMS_GetLoanDetails({
            Loan_Id: this.LoanId,
            DueDate: this.VoucherDateTo,
            LoginUserId: this.currentUser.userId
          })
          .subscribe((res: any) => {
            // console.log("res :", res);
            this.showSpinner = false;
            this.printedByUser = this.currentUser.FullName;
            this.getAccHeadDetails(
              this.ApplicationNo,
              this.LoanNo,
              this.VoucherDateTo
            );
            this.EMIDetails = res.Item7[0];
            this.repaymentInstrument = res.Item10;

            this.repaymentInstrumentsClear = (res.Item10 || []).filter(
              (x) => x.Type === "Clear"
            );
            this.repaymentInstrumentsBounce = (res.Item10 || []).filter(
              (x) => x.Type === "Bounce"
            );
            this.loadAllCollateralData(res.Item6);
            $("#LoanSOAPrintModel").modal("show");
            $("#LoanSOAPrintModel").css("z-index", "1050");
          });

      // });
  }
  calculateDeductionTotal() {
    if (this.ChargesDataSource != null) {
      let sum = 0.0;
      for (let i = 0; i < this.ChargesDataSource.filteredData.length; i++) {
        sum += Number(this.ChargesDataSource.filteredData[i]["Deduction"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateReceiptTotal() {
    if (this.ChargesDataSource != null) {
      let sum = 0.0;
      for (let i = 0; i < this.ChargesDataSource.filteredData.length; i++) {
        sum += Number(this.ChargesDataSource.filteredData[i]["Receipt"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  // LoanStatementPrint() {
  //   this.dialog
  //     .openConfirmDialog("Show with Account Summary")
  //     .afterClosed()
  //     .subscribe((dialogResult) => {
  //       if (dialogResult == false) {
  //         this.lmsService
  //           .LMS_GetLoanDetails({
  //             Loan_Id: this.LoanId,
  //             DueDate: this.VoucherDateTo,
  //           })
  //           .subscribe((res: any) => {
  //             // console.log("res :", res);
  //             this.showSpinner = false;

  //             this.EMIDetails = res.Item7[0];

  //             $("#LoanStatementPrintModel").modal("show");
  //             $("#LoanStatementPrintModel").css("z-index", "1050");
  //             this.withAccountSummary = false;
  //           });
  //       } else {
  //         this.lmsService
  //           .LMS_GetLoanDetails({
  //             Loan_Id: this.LoanId,
  //             DueDate: this.VoucherDateTo,
  //           })
  //           .subscribe((res: any) => {
  //             // console.log("res :", res);
  //             this.showSpinner = false;

  //             this.EMIDetails = res.Item7[0];
  //             $("#LoanStatementPrintModel").modal("show");
  //             $("#LoanStatementPrintModel").css("z-index", "1050");
  //           });
  //         this.withAccountSummary = true;
  //         console.log("repaymentInstrument", this.repaymentInstrument);
  //       }
  //     });
  // }
  LoanStatementPrint() {
    const selectedSections = this.filteredStatementSectionList.filter(
      section => this.statementSections[section.key]
    );

    if (selectedSections.length === 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No section selected for print",
        ...this.configSuccess, // or configError if you have one
      });
      return;
    }

    this.lmsService
      .LMS_GetLoanDetails({
        Loan_Id: this.LoanId,
        DueDate: this.VoucherDateTo,
        LoginUserId: this.currentUser.userId
      })
      .subscribe((res: any) => {
        // console.log("res :", res);
        this.showSpinner = false;
        this.printedByUser = this.currentUser.FullName;
        this.EMIDetails = res.Item7[0];

        $("#LoanStatementPrintModel").modal("show");
        $("#LoanStatementPrintModel").css("z-index", "1050");
        // this.withAccountSummary = false;
      });
  }

  onCloseLoanSOALegalPrintModel() {
    $("#LoanSOALegalPrintModel").modal("hide");
  }

  LoanSOALegalPrint() {
    this.lmsService
      .LMS_GetLoanDetails({ Loan_Id: this.LoanId, DueDate: this.VoucherDateTo, LoginUserId: this.currentUser.userId })
      .subscribe((res: any) => {
        // console.log("res :", res);
        this.showSpinner = false;
        this.printedByUser = this.currentUser.FullName;
        this.EMIDetails = res.Item7[0];
        this.DisbursementDetails = res.Item8;
        this.calculateTotalDR();
        this.calculateTotalCR();
        // console.log("Dis Amount", this.DisbursementDetails);
        $("#LoanSOALegalPrintModel").modal("show");
        $("#LoanSOALegalPrintModel").css("z-index", "1050");
      });
  }

  calculateTotalDR() {
    for (let DisbursementDetail of this.DisbursementDetails) {
      const DRAmount = parseFloat(DisbursementDetail.DRAmount);
      this.totalDRAmount += DRAmount;
    }
    // console.log("Total DR Amount", this.totalDRAmount.toFixed(2));
  }
  calculateTotalCR() {
    for (let DisbursementDetail of this.DisbursementDetails) {
      const CRAmount = parseFloat(DisbursementDetail.CRAmount);
      this.totalCRAmount += CRAmount;
    }
    // console.log("Total CR Amount", this.totalCRAmount);
  }

  // showInfoCard(event: MouseEvent, row: any) {
  //   this.hoveredRow = row;
  //   this.hoverX = event.clientX;
  //   this.hoverY = event.clientY;
  // }

  showInfoCard(event: MouseEvent, row: any) {
    this.hoveredRow = row;
    console.log("you have entered");

    const spanElement = event.target as HTMLElement; // Get the span element
    const rect = spanElement.getBoundingClientRect(); // Get its position

    this.hoverX = rect.left + window.scrollX + 30;
    this.hoverY = rect.top + window.scrollY - 120;
  }
  hideInfoCard() {
    this.hoveredRow = null;
  }
  exportToExcelSOA() {
    this.showSpinner = true;

    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    workbook.creator = this.currentUser.CompanyName;
    workbook.created = new Date();

    // Add a worksheet
    const worksheet = workbook.addWorksheet('SOA Report');

    const themeArgb = this._commonfunctions.getThemeColorArgb();

    // Define styles
    const headerStyle = {
      font: {
        bold: true,
        size: 12,
        color: { argb: 'FFFFFFFF' },
        name: 'Times New Roman'
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: themeArgb }
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true
      },
      border: {
        top: { style: 'thin' as any },
        left: { style: 'thin' as any },
        bottom: { style: 'thin' as any },
        right: { style: 'thin' as any }
      }
    };

    const sectionHeaderStyle = {
      font: {
        bold: true,
        size: 11,
        color: { argb: 'FFFFFFFF' },
        name: 'Times New Roman'
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: themeArgb }
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'center'
      },
      border: {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    };

    const titleStyle = {
      font: {
        bold: true,
        size: 14,
        name: 'Times New Roman'
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'center'
      }
    };

    const labelCellStyle = {
      font: {
        bold: true,
        size: 10,
        name: 'Times New Roman'
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'left'
      },
      border: {
        top: { style: 'thin' as any },
        left: { style: 'thin' as any },
        bottom: { style: 'thin' as any },
        right: { style: 'thin' as any }
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF0F0F0' } // Light gray background for labels
      }
    };

    const valueCellStyle = {
      font: {
        size: 10,
        name: 'Times New Roman'
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'left'
      },
      border: {
        top: { style: 'thin' as any },
        left: { style: 'thin' as any },
        bottom: { style: 'thin' as any },
        right: { style: 'thin' as any }
      }
    };

    const rightAlignedValueStyle = {
      font: {
        size: 10,
        name: 'Times New Roman'
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'right'
      },
      border: {
        top: { style: 'thin' as any },
        left: { style: 'thin' as any },
        bottom: { style: 'thin' as any },
        right: { style: 'thin' as any }
      }
    };

    const centerAlignedCellStyle = {
      font: {
        size: 10,
        name: 'Times New Roman'
      },
      alignment: {
        vertical: 'middle',
        horizontal: 'center'
      },
      border: {
        top: { style: 'thin' as any },
        left: { style: 'thin' as any },
        bottom: { style: 'thin' as any },
        right: { style: 'thin' as any }
      }
    };

    let currentRow = 1;

    // ==================== COMPANY HEADER ====================
    // Add company name
    const companyRow = worksheet.addRow([this.currentUser.CompanyName]);
    companyRow.height = 25;
    const companyCell = companyRow.getCell(1);
    Object.assign(companyCell, titleStyle);
    companyCell.font.size = 16;
    worksheet.mergeCells(companyRow.number, 1, companyRow.number, 8);
    currentRow++;

    // Add company address
    const addressRow = worksheet.addRow([`Address : ${this.currentUser.CompanyAddress}`]);
    addressRow.height = 22;
    const addressCell = addressRow.getCell(1);
    addressCell.font = { size: 11, name: 'Times New Roman' };
    addressCell.alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.mergeCells(addressRow.number, 1, addressRow.number, 8);
    currentRow++;

    // Add loan account statement title
    const customerGender = this.customerData && this.customerData[0]
      ? this.customerData[0].GenderAge.split(",")[0] == "Male" ? "Mr" : "Ms"
      : "";
    const customerName = this.customerData && this.customerData[0]
      ? this.customerData[0].Customer
      : "";

    const statementTitle = `Loan Account Statement for : ${this.ApplicationDetail?.LoanAcNo || ''} (${customerGender} ${customerName})`;
    const statementRow = worksheet.addRow([statementTitle]);
    statementRow.height = 24;
    const statementCell = statementRow.getCell(1);
    statementCell.font = { bold: true, size: 12, name: 'Times New Roman' };
    statementCell.alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.mergeCells(statementRow.number, 1, statementRow.number, 8);
    currentRow += 2;

    // ==================== LOAN ACCOUNT INFORMATION ====================
    const accountInfoTitle = `Loan Account Information as on - ${this.datePipe.transform(this.VoucherDateTo, 'dd/MM/yyyy')}${this.ApplicationDetail?.DPD_DAYS != null ? '                                                                                                        DPD : ' + this.ApplicationDetail.DPD_DAYS : ''}`;
    const accountInfoRow = worksheet.addRow([accountInfoTitle]);
    accountInfoRow.height = 28;
    const accountInfoCell = accountInfoRow.getCell(1);
    Object.assign(accountInfoCell, headerStyle);
    accountInfoCell.font.size = 12;
    worksheet.mergeCells(accountInfoRow.number, 1, accountInfoRow.number, 8);
    currentRow++;
    worksheet.addRow([]);
    currentRow += 2;
    // ==================== LOAN DETAIL SECTION ====================
    if (this.soaSections.loanDetail && this.ApplicationDetail) {
      // Add section header
      const loanDetailHeader = worksheet.addRow(['Loan Detail:']);
      loanDetailHeader.height = 25;
      const loanDetailHeaderCell = loanDetailHeader.getCell(1);
      Object.assign(loanDetailHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(loanDetailHeader.number, 1, loanDetailHeader.number, 6);
      currentRow++;

      // Define loan details with label-value pairs (3 pairs per row)
      const loanDetailRows = [
        // Row 1: Application No, Application Date, Loan No
        [
          { label: 'Application No:', value: this.ApplicationDetail.ApplicationNo || '' },
          { label: 'Application Date:', value: this.ApplicationDetail.ApplicationCreateOn || '' },
          { label: 'Loan No:', value: this.ApplicationDetail.LoanAcNo || '' }
        ],
        // Row 2: Loan Date, Branch, Product
        [
          { label: 'Loan Date:', value: this.ApplicationDetail.Loan_Date || '' },
          { label: 'Branch:', value: this.ApplicationDetail.Branch || '' },
          { label: 'Product:', value: this.ApplicationDetail.Product || '' }
        ],
        // Row 3: Loan Purpose, Expiry Date, Close Date
        [
          { label: 'Loan Purpose:', value: this.ApplicationDetail.LoanPurpose || '' },
          { label: 'Maturity Date:', value: this.ApplicationDetail.ExpiryDate || '' },
          { label: 'Close Date:', value: this.ApplicationDetail.CloseDate || '' }
        ],
        [
          { label: 'Loan Amount:', value: this.ApplicationDetail.NetFinance || '' },
          { label: 'No Of Installments:', value: this.ApplicationDetail.No_Of_Instl || '' },
          { label: 'First EMI Date:', value: this.ApplicationDetail.FirstEMIDate || '' }
        ],
        [
          { label: 'Reducing ROI:', value: this.ApplicationDetail.Case_IRR || '' }
        ]
      ];

      // Add loan detail rows
      loanDetailRows.forEach(rowData => {
        const row = worksheet.addRow([]);
        row.height = 20;

        // Each row has 6 cells (3 label-value pairs)
        for (let i = 0; i < rowData.length; i++) {
          const labelCell = row.getCell((i * 2) + 1);
          const valueCell = row.getCell((i * 2) + 2);

          labelCell.value = rowData[i].label;
          Object.assign(labelCell, labelCellStyle);

          valueCell.value = rowData[i].value;
          Object.assign(valueCell, valueCellStyle);
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += loanDetailRows.length + 1;
    }

    // ==================== CUSTOMER DETAIL SECTION ====================
    if (this.soaSections.customerDetail && this.customerData && this.customerData.length > 0) {
      // Add section header
      const customerHeader = worksheet.addRow(['Customer Detail:']);
      customerHeader.height = 25;
      const customerHeaderCell = customerHeader.getCell(1);
      Object.assign(customerHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(customerHeader.number, 1, customerHeader.number, 6);
      currentRow++;

      // Add customer table headers
      const customerHeaders = ['#', 'Name', 'Type', 'Gender/Age', 'Phone No', 'Present Address'];
      const customerHeaderRow = worksheet.addRow(customerHeaders);
      customerHeaderRow.height = 22;

      customerHeaders.forEach((header, index) => {
        const cell = customerHeaderRow.getCell(index + 1);
        Object.assign(cell, headerStyle);
        cell.font.size = 10;
      });
      currentRow++;

      // Add customer data
      this.customerData.forEach((customer, index) => {
        const phoneNo = this.currentUser.IsMaskingMobile
          ? this.maskPhoneNumber(customer.PhoneNo || '')
          : customer.PhoneNo || '';
        const customerType = customer.CustomerType == "Hirer" ? "Borrower" : customer.CustomerType;

        const customerRow = worksheet.addRow([
          index + 1,
          customer.Customer || '',
          customerType,
          customer.GenderAge || '',
          phoneNo,
          customer.Present_Address || ''
        ]);

        customerRow.height = 18;
        customerRow.eachCell((cell, colNumber) => {
          Object.assign(cell, valueCellStyle);
          if (colNumber === 1) { // # column
            cell.alignment.horizontal = 'center';
          }
          if (colNumber === 6) {
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
              wrapText: true
            };
          }
        });
        currentRow++;
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += 2;
    }

    // ==================== FINANCIAL DETAIL SECTION ====================
    if (this.soaSections.financeDetail && this.ApplicationDetail) {
      // Add section header
      const financeHeader = worksheet.addRow(['Financial Detail:']);
      financeHeader.height = 25;
      const financeHeaderCell = financeHeader.getCell(1);
      Object.assign(financeHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(financeHeader.number, 1, financeHeader.number, 6);
      currentRow++;

      // Define financial details with label-value pairs (3 pairs per row)
      const financialDetailRows = [
        // Row 1: Asset Cost, Net Finance, Interest Amount
        [
          { label: 'Asset Cost:', value: this.ApplicationDetail.AssetCost?.toFixed(2) || '0.00' },
          { label: 'Loan Amount:', value: this.ApplicationDetail.NetFinance?.toFixed(2) || '0.00' },
          { label: 'Interest Amount:', value: this.ApplicationDetail.InterestAmt?.toFixed(2) || '0.00' }
        ],
        // Row 2: Agreement Value, LTV, Margin
        [
          { label: 'Agreement Value:', value: this.ApplicationDetail.AgreementValue?.toFixed(2) || '0.00' },
          { label: 'LTV:', value: `${this.ApplicationDetail.LTV?.toFixed(2) || '0.00'}%` },
          { label: 'Margin:', value: this.ApplicationDetail.Margin?.toFixed(2) || '0.00' }
        ],
        // Row 3: Tenure, No of Installment, Adv. Installment
        [
          { label: `Tenure (${this.TenureName}):`, value: `${this.ApplicationDetail.Tenure || ''} ${this.TenureName}` },
          { label: 'No of Installment:', value: this.ApplicationDetail.No_Of_Instl || '' },
          { label: 'Adv. Installment:', value: this.ApplicationDetail.Adv_Instl || '' }
        ],
        // Row 4: ROI, Case IRR, First EMI Date
        [
          { label: 'ROI:', value: `${this.ApplicationDetail.Flat_Rate || ''}%` },
          { label: 'Case IRR:', value: `${this.ApplicationDetail.Case_IRR?.toFixed(2) || '0.00'}%` },
          { label: 'First EMI Date:', value: this.ApplicationDetail.FirstEMIDate || '' }
        ],
        // Row 5: Expiry Date, Close Date (only 2 pairs)
        [
          { label: 'Maturity Date:', value: this.ApplicationDetail.ExpiryDate || '' },
          { label: 'Close Date:', value: this.ApplicationDetail.CloseDate || '' },
          { label: '', value: '' } // Empty pair for formatting
        ]
      ];

      // Add financial detail rows
      financialDetailRows.forEach(rowData => {
        const row = worksheet.addRow([]);
        row.height = 20;

        // Each row has 6 cells (3 label-value pairs)
        for (let i = 0; i < 3; i++) {
          const labelCell = row.getCell((i * 2) + 1);
          const valueCell = row.getCell((i * 2) + 2);

          if (rowData[i] && rowData[i].label) {
            labelCell.value = rowData[i].label;
            Object.assign(labelCell, labelCellStyle);

            valueCell.value = rowData[i].value;
            Object.assign(valueCell, valueCellStyle);
          } else {
            // For empty pairs, clear the cells
            labelCell.value = '';
            valueCell.value = '';
          }
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += financialDetailRows.length + 1;
    }
    // ==================== DISBURSEMENT DETAIL SECTION ====================
    if (
      this.soaSections.disbursementDetail &&
      this.ProcessHeadList &&
      this.ProcessHeadList.length > 0
    ) {

      // Add section header
      const disbursementHeader = worksheet.addRow(['Disbursement Detail:']);
      disbursementHeader.height = 25;

      const disbursementHeaderCell = disbursementHeader.getCell(1);
      Object.assign(disbursementHeaderCell, sectionHeaderStyle);

      worksheet.mergeCells(
        disbursementHeader.number,
        1,
        disbursementHeader.number,
        5
      );

      currentRow++;

      // Table headers
      const disbursementHeaders = [
        'Case No',
        'Customer',
        'Upfront Charges',
        'Debit',
        'Credit'
      ];

      const disbursementHeaderRow = worksheet.addRow(disbursementHeaders);
      disbursementHeaderRow.height = 22;

      disbursementHeaders.forEach((header, index) => {
        const cell = disbursementHeaderRow.getCell(index + 1);

        Object.assign(cell, headerStyle);
        cell.font.size = 10;
      });

      currentRow++;

      // Data rows
      this.ProcessHeadList.forEach((row) => {

        const disbursementRow = worksheet.addRow([
          row.CaseNo || '',
          row.Customer || '',
          row.ChagesHead || '',
          row.Deduction || '0.00',
          row.Receipt || '0.00'
        ]);

        disbursementRow.height = 18;

        disbursementRow.eachCell((cell, colNumber) => {

          // Debit & Credit right aligned
          if (colNumber === 4 || colNumber === 5) {
            Object.assign(cell, rightAlignedValueStyle);
          } else {
            Object.assign(cell, valueCellStyle);
          }
        });

        currentRow++;
      });

      // Total row
      const disbursementTotalRow = worksheet.addRow([
        '',
        '',
        'Total',
        this.calculateDeductionTotal() || '0.00',
        this.calculateReceiptTotal() || '0.00'
      ]);

      disbursementTotalRow.height = 20;

      disbursementTotalRow.eachCell((cell, colNumber) => {

        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4DC3A3' }
        };

        cell.border = headerStyle.border;

        cell.font = {
          bold: true,
          size: 10,
          name: 'Times New Roman'
        };

        if (colNumber === 4 || colNumber === 5) {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right'
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left'
          };
        }
      });

      // Blank row after section
      worksheet.addRow([]);
      currentRow += 2;
    }

    // ==================== EMI DETAIL SECTION ====================
    if (this.soaSections.emiDetail && this.EMIDetails) {
      // Add section header
      const emiHeader = worksheet.addRow(['EMI Detail:']);
      emiHeader.height = 25;
      const emiHeaderCell = emiHeader.getCell(1);
      Object.assign(emiHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(emiHeader.number, 1, emiHeader.number, 6);
      currentRow++;

      // Add EMI table headers
      const emiHeaders = ['', 'Total EMI', 'Mature EMI', 'Remaining EMI', 'Received EMI', 'Overdue EMI'];
      const emiHeaderRow = worksheet.addRow(emiHeaders);
      emiHeaderRow.height = 22;

      emiHeaders.forEach((header, index) => {
        const cell = emiHeaderRow.getCell(index + 1);
        Object.assign(cell, headerStyle);
        cell.font.size = 10;
      });
      currentRow++;

      // Add EMI count row
      const overdueEMI = (this.EMIDetails.MatureEMI || 0) - (this.EMIDetails.Received_EMI || 0);
      const emiCountRow = worksheet.addRow([
        'EMI',
        this.EMIDetails.TotalEMI || 0,
        this.EMIDetails.MatureEMI || 0,
        this.EMIDetails.Remaining_EMI || 0,
        this.EMIDetails.Received_EMI || 0,
        overdueEMI > 0 ? overdueEMI : 0
      ]);

      emiCountRow.height = 20;
      emiCountRow.eachCell((cell, colNumber) => {
        Object.assign(cell, centerAlignedCellStyle);
        if (colNumber === 1) {
          cell.font.bold = true;
        }
      });
      currentRow++;

      // Add EMI amount row
      const overdueAmount = (this.EMIDetails.MatureEMI_Amount || 0) - (this.EMIDetails.Received_EMI_Amount || 0);
      const emiAmountRow = worksheet.addRow([
        'Amount',
        `₹${this.EMIDetails.TotalEMI_Amount || '0.00'}`,
        `₹${this.EMIDetails.MatureEMI_Amount || '0.00'}`,
        `₹${this.EMIDetails.Remaining_EMI_Amount || '0.00'}`,
        `₹${this.EMIDetails.Received_EMI_Amount || '0.00'}`,
        overdueAmount > 0 ? `₹${overdueAmount.toFixed(2)}` : '₹0.00'
      ]);

      emiAmountRow.height = 20;
      emiAmountRow.eachCell((cell, colNumber) => {
        Object.assign(cell, centerAlignedCellStyle);
        if (colNumber === 1) {
          cell.font.bold = true;
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += 3;
    }
    // ==================== ASSET DETAILS SECTION ====================
    if (this.soaSections.AssetsDetail && this.allCollateralData && this.allCollateralData.length > 0) {
      // Add section header
      const assetHeader = worksheet.addRow(['Assets Details:']);
      assetHeader.height = 25;
      const assetHeaderCell = assetHeader.getCell(1);
      Object.assign(assetHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(assetHeader.number, 1, assetHeader.number, 6);
      currentRow++;

      // Process each collateral
      this.allCollateralData.forEach((collateralData: any, index: number) => {
        if (collateralData.data && collateralData.data.length > 0) {
          const collateral = collateralData.data[0];

          // Add collateral header (Primary/Additional)
          const collateralTypeHeader = worksheet.addRow([
            index === 0 ? 'Primary Collateral:' : 'Additional Collateral:'
          ]);
          collateralTypeHeader.height = 22;
          const collateralTypeHeaderCell = collateralTypeHeader.getCell(1);
          collateralTypeHeaderCell.font = { bold: true, size: 12, name: 'Times New Roman' };
          collateralTypeHeaderCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF8EC2BE' } // Light teal background
          };
          collateralTypeHeaderCell.alignment = { vertical: 'middle', horizontal: 'left' };
          worksheet.mergeCells(collateralTypeHeader.number, 1, collateralTypeHeader.number, 6);
          currentRow++;

          // Collateral Type Details Row
          const typeRow = worksheet.addRow([]);
          typeRow.height = 20;

          // Collateral Type
          const typeLabelCell = typeRow.getCell(1);
          typeLabelCell.value = 'Collateral Type:';
          Object.assign(typeLabelCell, labelCellStyle);

          const typeValueCell = typeRow.getCell(2);
          typeValueCell.value = collateral.Collateral_Type || '';
          Object.assign(typeValueCell, valueCellStyle);

          // Collateral
          const collateralLabelCell = typeRow.getCell(3);
          collateralLabelCell.value = 'Collateral:';
          Object.assign(collateralLabelCell, labelCellStyle);

          const collateralValueCell = typeRow.getCell(4);
          collateralValueCell.value = collateral.Collateral || '';
          Object.assign(collateralValueCell, valueCellStyle);

          // Valuation Type
          const valuationTypeLabelCell = typeRow.getCell(5);
          valuationTypeLabelCell.value = 'Valuation Type:';
          Object.assign(valuationTypeLabelCell, labelCellStyle);

          const valuationTypeValueCell = typeRow.getCell(6);
          valuationTypeValueCell.value = collateral.ValuationType || '';
          Object.assign(valuationTypeValueCell, valueCellStyle);

          currentRow++;

          // Valuation Details Row
          const valuationRow = worksheet.addRow([]);
          valuationRow.height = 20;

          // Valuation Amount
          const valuationAmtLabelCell = valuationRow.getCell(1);
          valuationAmtLabelCell.value = 'Valuation Amount:';
          Object.assign(valuationAmtLabelCell, labelCellStyle);

          const valuationAmtValueCell = valuationRow.getCell(2);
          // Format as currency if it's a number
          const valuationAmount = collateral.ValuationAmount || '';
          valuationAmtValueCell.value = typeof valuationAmount === 'number' ?
            `₹${valuationAmount.toFixed(2)}` : valuationAmount;
          Object.assign(valuationAmtValueCell, valueCellStyle);

          // Valuation Date
          const valuationDateLabelCell = valuationRow.getCell(3);
          valuationDateLabelCell.value = 'Valuation Date:';
          Object.assign(valuationDateLabelCell, labelCellStyle);

          const valuationDateValueCell = valuationRow.getCell(4);
          valuationDateValueCell.value = this.formatDate(collateral.ValuationDate) || '';
          Object.assign(valuationDateValueCell, valueCellStyle);

          // // Insurance Amount
          // const insuranceLabelCell = valuationRow.getCell(5);
          // insuranceLabelCell.value = 'Insurance Amount:';
          // Object.assign(insuranceLabelCell, labelCellStyle);

          // const insuranceValueCell = valuationRow.getCell(6);
          // // Format as currency if it's a number
          // const insuranceAmount = collateral.InsuranceAmount || '';
          // insuranceValueCell.value = typeof insuranceAmount === 'number' ? 
          //     `₹${insuranceAmount.toFixed(2)}` : insuranceAmount;
          // Object.assign(insuranceValueCell, valueCellStyle);

          currentRow++;

          // Vehicle Details (if collateral is a Vehicle)
          if (collateral.Collateral === 'Vehicle') {
            // Vehicle Row 1
            const vehicleRow1 = worksheet.addRow([]);
            vehicleRow1.height = 20;

            // Manufacture
            const manufactureLabelCell = vehicleRow1.getCell(1);
            manufactureLabelCell.value = 'Manufacture:';
            Object.assign(manufactureLabelCell, labelCellStyle);

            const manufactureValueCell = vehicleRow1.getCell(2);
            manufactureValueCell.value = collateral.VehicleManufacture || '';
            Object.assign(manufactureValueCell, valueCellStyle);

            // Vehicle Category
            const categoryLabelCell = vehicleRow1.getCell(3);
            categoryLabelCell.value = 'Vehicle Category:';
            Object.assign(categoryLabelCell, labelCellStyle);

            const categoryValueCell = vehicleRow1.getCell(4);
            categoryValueCell.value = collateral.VehicleCategory || '';
            Object.assign(categoryValueCell, valueCellStyle);

            // Model Name
            const modelLabelCell = vehicleRow1.getCell(5);
            modelLabelCell.value = 'Model Name:';
            Object.assign(modelLabelCell, labelCellStyle);

            const modelValueCell = vehicleRow1.getCell(6);
            modelValueCell.value = collateral.VehicleModelName || '';
            Object.assign(modelValueCell, valueCellStyle);

            currentRow++;

            // Vehicle Row 2
            const vehicleRow2 = worksheet.addRow([]);
            vehicleRow2.height = 20;

            // Variant
            const variantLabelCell = vehicleRow2.getCell(1);
            variantLabelCell.value = 'Variant:';
            Object.assign(variantLabelCell, labelCellStyle);

            const variantValueCell = vehicleRow2.getCell(2);
            variantValueCell.value = collateral.Variant || '';
            Object.assign(variantValueCell, valueCellStyle);

            // Engine No
            const engineLabelCell = vehicleRow2.getCell(3);
            engineLabelCell.value = 'Engine No:';
            Object.assign(engineLabelCell, labelCellStyle);

            const engineValueCell = vehicleRow2.getCell(4);
            engineValueCell.value = collateral.EngineNo || '';
            Object.assign(engineValueCell, valueCellStyle);

            // Chassis No
            const chassisLabelCell = vehicleRow2.getCell(5);
            chassisLabelCell.value = 'Chassis No:';
            Object.assign(chassisLabelCell, labelCellStyle);

            const chassisValueCell = vehicleRow2.getCell(6);
            chassisValueCell.value = collateral.ChassisNo || '';
            Object.assign(chassisValueCell, valueCellStyle);

            currentRow++;

            // Vehicle Row 3
            const vehicleRow3 = worksheet.addRow([]);
            vehicleRow3.height = 20;

            // Vehicle Registration No
            const regLabelCell = vehicleRow3.getCell(1);
            regLabelCell.value = 'Vehicle Registration No:';
            Object.assign(regLabelCell, labelCellStyle);

            const regValueCell = vehicleRow3.getCell(2);
            regValueCell.value = collateral.VehicleRegistationNo || '';
            Object.assign(regValueCell, valueCellStyle);

            // Merge remaining cells
            worksheet.mergeCells(vehicleRow3.number, 3, vehicleRow3.number, 6);

            currentRow++;
          }

          // Add spacing between different collaterals (except after last one)
          if (index < this.allCollateralData.length - 1) {
            const emptyRow = worksheet.addRow([]);
            emptyRow.height = 10;
            currentRow++;
          }
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow++;
    }

    // ==================== ACCOUNT SUMMARY SECTION ====================
    if (this.soaSections.accountSummary && this.AccHeadSummary && this.AccHeadSummary.length > 0) {
      // Add section header
      const summaryHeader = worksheet.addRow(['Account Summary:']);
      summaryHeader.height = 25;
      const summaryHeaderCell = summaryHeader.getCell(1);
      Object.assign(summaryHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(summaryHeader.number, 1, summaryHeader.number, 5);
      currentRow++;

      // Add table headers
      const summaryHeaders = ['#', 'Account Head', 'Debit', 'Credit', 'Balance'];
      const summaryHeaderRow = worksheet.addRow(summaryHeaders);
      summaryHeaderRow.height = 22;

      summaryHeaders.forEach((header, index) => {
        const cell = summaryHeaderRow.getCell(index + 1);
        Object.assign(cell, headerStyle);
        cell.font.size = 10;
      });
      currentRow++;

      // Add data rows
      this.AccHeadSummary.forEach((item, index) => {
        const summaryRow = worksheet.addRow([
          index + 1,
          item.ChagesHead || '',
          item.TranTypeDR || '0.00',
          item.TranTypeCR || '0.00',
          item.TranTypeTotal || '0.00'
        ]);

        summaryRow.height = 18;
        summaryRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            Object.assign(cell, centerAlignedCellStyle);
          } else if (colNumber >= 3 && colNumber <= 5) {
            Object.assign(cell, rightAlignedValueStyle);
          } else {
            Object.assign(cell, valueCellStyle);
          }
        });
        currentRow++;
      });

      // Add total row
      const totalRow = worksheet.addRow([
        '',
        'Total',
        this.calculateChargesTranTypeDR("OD") || '0.00',
        this.calculateChargesTranTypeCR("OD") || '0.00',
        this.calculateChargesTranTypeTotal("OD") || '0.00'
      ]);

      totalRow.height = 20;
      totalRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.border = headerStyle.border;
        } else if (colNumber === 2) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.font = { bold: true, size: 10, name: 'Times New Roman', color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
          cell.border = headerStyle.border;
        } else if (colNumber >= 3 && colNumber <= 5) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.font = { bold: true, size: 10, name: 'Times New Roman', color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'right' };
          cell.border = headerStyle.border;
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += 2;
    }

    // ==================== ACCOUNT DETAILS SECTION ====================
    if (this.AccHeadDetails && this.AccHeadDetails.length > 0) {
      // Add section header
      const accountDetailsHeader = worksheet.addRow(['Account Details:']);
      accountDetailsHeader.height = 25;
      const accountDetailsHeaderCell = accountDetailsHeader.getCell(1);
      Object.assign(accountDetailsHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(accountDetailsHeader.number, 1, accountDetailsHeader.number, 8);
      currentRow++;

      // Add table headers
      const accountHeaders = ['#', 'Voucher Date', 'Voucher No', 'A/C Head', 'DR Amount', 'CR Amount', 'Balance', 'Narration'];
      const accountHeaderRow = worksheet.addRow(accountHeaders);
      accountHeaderRow.height = 22;

      accountHeaders.forEach((header, index) => {
        const cell = accountHeaderRow.getCell(index + 1);
        Object.assign(cell, headerStyle);
        cell.font.size = 10;
      });
      currentRow++;

      // Add data rows
      this.AccHeadDetails.forEach((item, index) => {
        const accountRow = worksheet.addRow([
          index + 1,
          item.VoucherDate || '',
          item.Voucher_No || '',
          item.ChagesHead || '',
          item.TranTypeDR || '0.00',
          item.TranTypeCR || '0.00',
          item.TranTypeTotal || '0.00',
          item.Narration || ''
        ]);

        accountRow.height = 18;
        accountRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            Object.assign(cell, centerAlignedCellStyle);
          } else if (colNumber >= 5 && colNumber <= 7) {
            Object.assign(cell, rightAlignedValueStyle);
          } else {
            Object.assign(cell, valueCellStyle);
          }
          if (colNumber === 8) {
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
              wrapText: true
            };
          }
        });
        currentRow++;
      });

      // Add total row
      const accountTotalRow = worksheet.addRow([
        '', '', '', 'Total',
        this.totaltypewise("TranTypeDR") || '0.00',
        this.totaltypewise("TranTypeCR") || '0.00',
        this.totaltypeAccountwise() || '0.00',
        ''
      ]);

      accountTotalRow.height = 20;
      accountTotalRow.eachCell((cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 3) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.border = headerStyle.border;
        } else if (colNumber === 4) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.font = { bold: true, size: 10, name: 'Times New Roman', color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
          cell.border = headerStyle.border;
        } else if (colNumber >= 5 && colNumber <= 7) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.font = { bold: true, size: 10, name: 'Times New Roman', color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'right' };
          cell.border = headerStyle.border;
        } else if (colNumber === 8) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.border = headerStyle.border;
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += 2;
    }

    // ==================== OD DETAILS SECTION ====================
    if (this.soaSections.odDetail && this.showLoanOD && this.ODDetails && this.ODDetails.length > 0) {
      // Add section header
      const odHeader = worksheet.addRow(['OD Details:']);
      odHeader.height = 25;
      const odHeaderCell = odHeader.getCell(1);
      Object.assign(odHeaderCell, sectionHeaderStyle);
      worksheet.mergeCells(odHeader.number, 1, odHeader.number, 8);
      currentRow++;

      // Add table headers
      const odHeaders = ['#', 'Voucher Date', 'Voucher No', 'OS Balance', 'Days', 'ODI Due', 'ODI Credit', 'ODI Balance'];
      const odHeaderRow = worksheet.addRow(odHeaders);
      odHeaderRow.height = 22;

      odHeaders.forEach((header, index) => {
        const cell = odHeaderRow.getCell(index + 1);
        Object.assign(cell, headerStyle);
        cell.font.size = 10;
      });
      currentRow++;

      // Add data rows
      this.ODDetails.forEach((item, index) => {
        const odRow = worksheet.addRow([
          index + 1,
          item.VoucherDate || '',
          item.Voucher_No || '',
          item.TT || '0.00',
          item.DaysLate || 0,
          item.ODDebit || '0.00',
          item.ODCredit || '0.00',
          item.ODTotal || '0.00'
        ]);

        odRow.height = 18;
        odRow.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            Object.assign(cell, centerAlignedCellStyle);
          } else if (colNumber === 4) {
            Object.assign(cell, rightAlignedValueStyle);
          } else if (colNumber === 5) {
            Object.assign(cell, centerAlignedCellStyle);
          } else if (colNumber >= 6 && colNumber <= 8) {
            Object.assign(cell, rightAlignedValueStyle);
          } else {
            Object.assign(cell, valueCellStyle);
          }
        });
        currentRow++;
      });

      // Add total row
      const odTotalRow = worksheet.addRow([
        '', '', '', '',
        'Total',
        this.calculateODInterest() || '0.00',
        this.calculateODCredit() || '0.00',
        this.calculateODTotal() || '0.00'
      ]);

      odTotalRow.height = 20;
      odTotalRow.eachCell((cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 4) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.border = headerStyle.border;
        } else if (colNumber === 5) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.font = { bold: true, size: 10, name: 'Times New Roman', color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
          cell.border = headerStyle.border;
        } else if (colNumber >= 6 && colNumber <= 8) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: themeArgb } };
          cell.font = { bold: true, size: 10, name: 'Times New Roman', color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'right' };
          cell.border = headerStyle.border;
        }
      });

      // Add blank row after section
      worksheet.addRow([]);
      currentRow += 2;
    }

    // ==================== ISSUE DATE ====================
    const issueDateRow = worksheet.addRow([`Issue Date : ${this.datePipe.transform(this.Cur_Date, 'dd/MM/yyyy')}`]);
    issueDateRow.height = 20;
    const issueDateCell = issueDateRow.getCell(1);
    issueDateCell.font = { size: 10, name: 'Times New Roman' };
    issueDateCell.alignment = { vertical: 'middle', horizontal: 'right' };
    worksheet.mergeCells(issueDateRow.number, 1, issueDateRow.number, 8);

    // ==================== SET COLUMN WIDTHS ====================
    // Set column widths for better formatting
    // We need 6 columns for Loan Details and Financial Details (3 label-value pairs)
    worksheet.columns = [
      { width: 15 },   // Column A: Labels or data
      { width: 20 },   // Column B: Values or data
      { width: 15 },   // Column C: Labels or data
      { width: 20 },   // Column D: Values or data
      { width: 15 },   // Column E: Labels or data
      { width: 20 },   // Column F: Values or data
      { width: 15 },   // Column G: For other tables
      { width: 30 }    // Column H: For other tables (Narration, etc.)
    ];

    // ==================== GENERATE EXCEL FILE ====================
    workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileName = `SOA_${this.ApplicationDetail?.LoanAcNo || 'Statement'}_${this.datePipe.transform(new Date(), 'yyyyMMdd_HHmmss')}.xlsx`;
      saveAs(blob, fileName);
      this.showSpinner = false;

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: 'SOA exported to Excel successfully!',
        ...this.configSuccess,
      });
    }).catch(error => {
      console.error('Error exporting to Excel:', error);
      this.showSpinner = false;

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: 'Error exporting SOA to Excel. Please try again.',
        ...this.configSuccess,
      });
    });
  }

  // Helper function for phone number masking
  maskPhoneNumber(phone: string): string {
    if (!phone) return '';
    // Simple masking: show only last 4 digits
    if (phone.length > 4) {
      return 'XXXXXX' + phone.slice(-4);
    }
    return phone;
  }
}